import React from "react";

export default function Tokenomics() {
  return (
    <div className="tokenomics">
      <div className="container">
        <div className="row">
          <div className="col-lg-3"></div>
          <div className="col-lg-6">
            <h1>Tokenomics</h1>
            <div className="row">
              <div className="col-6">
                <h6>total</h6>
                <h6>liquidity</h6>
                <h6>marketing</h6>
                <h6>treasury tax</h6>
              </div>
              <div className="col-6 text-right">
                <h5>13 %</h5>
                <h5>3 %</h5>
                <h5>5 %</h5>
                <h5>5 %</h5>
              </div>
            </div>
          </div>
          <div className="col-lg-3"></div>
        </div>
      </div>
    </div>
  );
}
